<template>
  <v-menu v-if="items.length">
      <template v-slot:activator="{ props }">
        <v-btn
          class="text-none"
          color="white"
          variant="flat"
          v-bind="props"
          :disabled='loading || !items.length'
        >
          Choose Tenant
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :value="index"
        >
          <v-list-item-title @click="chooseTenant(item)">{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
</template>

<script>
  export default {
    data() {
      return {
        items: [],
        error: null,
        loading: true
      }
    },
    methods: {
      chooseTenant(tenant) {
        this.$emit('chooseTenant', tenant)
      },
      async getTenants() {
        this.loading = true;
        if (!this.items.length) {
          const response = await this.$modelValidationClient.getTenants();
          if (!response.data?.length) {
            this.error = "No tenants in the system yet."
            this.loading = false;
            return;
          }
          this.items = response.data.map(tenant => ({
            title: `${tenant.name} (${tenant.tenantType})`,
            value: tenant.tenantId
          }))

        }
        this.loading = false;
      }
    },
    async created () {
      this.error = null;
      await this.getTenants();            
    },
  }
</script>